if (!window.customElements.get("recently-viewed-products")) {
class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
        const query = this.buildQuery();
        if (query) this.loadProducts(query);
    }

    buildQuery() {
        let items = [];
        try { const stored = JSON.parse(localStorage.getItem("recently-viewed") || "[]"); if (Array.isArray(stored)) items = [...new Set(stored.map(Number).filter(id => Number.isSafeInteger(id) && id > 0))]; } catch { return ""; }
        const excludeId = this.getAttribute("exclude-id");
        if (excludeId) {
            const index = items.indexOf(parseInt(excludeId));
            if (index !== -1) items.splice(index, 1);
        }
        return items.slice(0, this.productLimit).map(id => `id:${id}`).join(" OR ");
    }

    async loadProducts(query) {
        try {
            const rootUrl = theme.routes.root_url.replace(/\/?$/, '/');
            const response = await fetch(`${rootUrl}search?q=${encodeURIComponent(query)}&resources[limit]=10&resources[type]=product&section_id=${this.sectionId}`);
            if (!response.ok) return;
            const html = await response.text();
            const products = new DOMParser().parseFromString(html, 'text/html').querySelector("recently-viewed-products");
            if (products && products.hasChildNodes()) {
                this.innerHTML = products.innerHTML;
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    }

    get sectionId() {
        return this.getAttribute("section-id");
    }

    get productLimit() {
        return parseInt(this.getAttribute("products-limit")) || 4;
    }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
